<style lang="scss" scoped>
.content-item {
  border: 1px solid #f4f5f9;

  .content-item__title {
    background: #f4f5f9;
    padding: 10px 20px;
  }

  .content-item_info {
    padding: 25px 0;
  }

  .content-item__echarts {
    height: 450px;
    // height: 400px;
  }
}
</style>

<template>
  <div class="content">
    <div class="content-item MB-20">
      <div class="content-item__title flex-row-between">
        <div class="content-item__title-left flex-row-start">
          <span class="text-bold">昨日运营数据</span>
        </div>
      </div>
      <div class="content-item_info flex-row-start text-16" v-if="dataSet.length">
        <div class="content-item__info-item flex-w__1 text-center">
          <p>发布量</p>
          <div class="text-18 text-bold MT-20">
            {{ dataSet[0].value || 0 }}
            <span :class="parseFloat(dataSet[0].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              dataSet[0].chainGrowthRatio || numSymbol }}%)</span>
          </div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>浏览量</p>
          <div class="text-18 text-bold MT-20">
            {{ dataSet[1].value || 0 }}
            <span :class="parseFloat(dataSet[1].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              dataSet[1].chainGrowthRatio | numSymbol }}%)</span>
          </div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>评论量</p>
          <div class="text-18 text-bold MT-20">
            {{ dataSet[2].value || 0 }}
            <span :class="parseFloat(dataSet[2].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              dataSet[2].chainGrowthRatio | numSymbol }}%)</span>
          </div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>关注量</p>
          <div class="text-18 text-bold MT-20">
            {{ dataSet[3].value || 0 }}
            <span :class="parseFloat(dataSet[3].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              dataSet[3].chainGrowthRatio | numSymbol }}%)</span>
          </div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>电话拨打量</p>
          <div class="text-18 text-bold MT-20">
            {{ dataSet[4].value || 0 }}
            <span :class="parseFloat(dataSet[4].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              dataSet[4].chainGrowthRatio | numSymbol }}%)</span>
          </div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>象币消耗量</p>
          <div class="text-18 text-bold MT-20">
            {{ dataSet[5].value || 0 }}
            <span :class="parseFloat(dataSet[5].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              dataSet[5].chainGrowthRatio | numSymbol }}%)</span>
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="tabDefaultName" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="核心数据查询" name="coreDataQuery">
        <div class="content-item">
          <div class="content-item__title flex-row-between">
            <div class="content-item__title-left flex-row-start">
              <el-select v-model="city" class="MR-20" placeholder="请选择城市" @change="getContentData" size="small">
                <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>

              <el-select v-model="dataType" class="MR-20 ML-20" placeholder="发布量" @change="getContentData" size="small">
                <el-option v-for="item in dataTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select v-model="timeType" class="MR-20 ML-20" placeholder="每日数据" @change="refreshPageDate" size="small">
                <el-option v-for="item in timeTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-date-picker v-model="date" :type="pickerDateType" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" :clearable="false"
                @change="getContentData" @focus="timeRegion = '0'" size="small"></el-date-picker>
            </div>
            <div class="content-item__title-right text-14 pointer text-blue text-bold" @click="downloadExcel">下载报表</div>
          </div>
          <div class="content-item_info content-item__echarts flex-row-start" ref="echarts"></div>
        </div>
        <div class="content-item_info flex-row-start text-16 MT-20 MB-20" v-if="totalDataSet.length">
          <div class="content-item__info-item flex-w__1 text-center">
            <p style="opacity:0;">0</p>
            <div class="text-18 text-bold MT-20">总计</div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>发布量</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[0].value || 0 }}
              <span :class="parseFloat(totalDataSet[0].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[0].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>浏览量</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[1].value || 0 }}
              <span :class="parseFloat(totalDataSet[1].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[1].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>评论量</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[2].value || 0 }}
              <span :class="parseFloat(totalDataSet[2].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[2].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>关注量</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[3].value || 0 }}
              <span :class="parseFloat(totalDataSet[3].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[3].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>电话拨打量</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[4].value || 0 }}
              <span :class="parseFloat(totalDataSet[4].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[4].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>象币消耗量</p>
          <div class="text-18 text-bold MT-20">
            {{ totalDataSet[5].value || 0 }}
            <span :class="parseFloat(totalDataSet[5].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
              totalDataSet[5].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
        </div>
        <el-table border :data="tableData" id="table" size="small" header-row-class-name="table-header">
          <el-table-column align="center" label="日期月份" prop="dataTime"></el-table-column>
          <el-table-column align="center" label="发布量" prop="releaseVolume"></el-table-column>
          <el-table-column align="center" label="浏览量" prop="browseVolume"></el-table-column>
          <el-table-column align="center" label="评论量" prop="remarkVolume"></el-table-column>
          <el-table-column align="center" label="关注量" prop="likeVolume"></el-table-column>
          <el-table-column align="center" label="电话拨打量" prop="dailVolume"></el-table-column>
          <el-table-column align="center" label="象币消耗量" prop="customer"></el-table-column>
          <!-- <el-table-column
                        align="center"
                        label="跳出率"
                        prop="time">

            </el-table-column>-->
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="参数数据查询" name="paramsDataQuery" lazy>
        <params-statistic ref="paramsDataQuery"></params-statistic>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const end = new Date();
const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
const startTime = getYear(start);
const endTime = getYear(end);

/**
 * 返回格式化的时间
 * @param {Date} date 当前需要格式化的时间对象
 * @param {Boolean} isTime 是否显示时分秒
 * @param {Boolean} onlyTime 是否仅仅只显示时分秒
 */
function getYear(date, isTime, onlyTime) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let time = year + "-" + get0(month) + "-" + get0(day);
  if (isTime) {
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (onlyTime) {
      time = get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    } else {
      time += " " + get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    }
  }

  return time;
}
function get0(num) {
  return num < 10 ? "0" + num : num;
}

import Echarts from "echarts";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import paramsStatistic from "./params-statistic.vue";
// import { stat } from "fs";
export default {
  components: { paramsStatistic },
  filters: {
    // 数字添加符号
    numSymbol: msg => {
      if (msg) {
        const douleN = parseFloat(msg);
        if (!douleN.isNaN) {
          return douleN > 0 ? "+" + msg : msg;
        } else {
          return msg;
        }
      } else {
        return msg;
      }
    }
  },
  data() {
    return {
      number1: 1,
      tabDefaultName: "coreDataQuery",
      //默认查询数据
      dataSet: [],
      // 总计数据
      totalDataSet: [],
      // 表格数据
      tableData: [
        // {
        //   dataTime: "2022-02-11",
        //   releaseVolume: 2000,
        //   browseVolume: 3000,
        //   remarkVolume: 3000,
        //   likeVolume: 2000,
        //   dailVolume: 3000,
        //   customer: 3000
        // }
      ],
      // 选中时间
      date: [startTime, endTime],
      // 当前数据类型
      dataType: "1",
      // 数据类型列表
      dataTypes: [
        {
          id: "1",
          name: "发布量"
        },
        {
          id: "2",
          name: "浏览量"
        },
        {
          id: "3",
          name: "评论量"
        },
        {
          id: "4",
          name: "关注量"
        },
        {
          id: "5",
          name: "电话拨打量"
        },
        {
          id: "6",
          name: "象鼻消耗量"
        }
      ],
      // 当前时间类型
      timeType: "1",
      // 当前时间范围
      timeRegion: "2",
      // 时间类型列表
      timeTypes: [
        {
          id: "1",
          name: "每日数据"
        },
        {
          id: "2",
          name: "每月数据"
        }
      ],
      // 当前城市
      city: "00",
      // 城市筛选列表
      cities: [
        {
          id: "00",
          name: "全部"
        }
      ],
      // 时间选择器类型
      pickerDateType: 'daterange',
      // 时间选择器配置
      pickerOptions: {},
      // 当前图表数据
      curContentData: [],
      // 内容图表数据
      contentDatas: {}
    };
  },
  computed: {
    /**
     * 返回当前数据获取类型
     */
    getTimeType() {
      if (this.date[0] && this.date[0] === this.date[1]) {
        return "hour";
      }
      return "day";
    }
  },
  created() {
    // console.log("create", this.date);
    this.dateTypeSelet(this.timeType);
  },
  mounted() {
    // console.log('mounted');
    const Loading = this.$loading();
    Promise.all([
      this.getCountAll(false),
      this.getCityList(false),
      this.getContentData(false)
      // this.getTableData(false),
    ])
      .then(res => {
        console.log('初始化数据请求',res);
        this.initEcharts();
      })
      .finally(() => {
        Loading.close();
      });
  },
  beforeDestroy() {
    this.lineChart = null
  },
  methods: {
    /**
     * 毫秒转换成分/秒
     */
    formatDuring(mss) {
      mss = Number(mss);
      if (isNaN(mss)) {
        return 0;
      }
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      return get0(minutes) + ":" + get0(Math.round(seconds));
    },
    // 
    handleTabClick() {
      this.$nextTick(() => {
          Echarts.getInstanceByDom(this.$refs.echarts).resize();
          Echarts.getInstanceByDom(this.$refs.paramsDataQuery.$refs.echartspie1).resize();
          Echarts.getInstanceByDom(this.$refs.paramsDataQuery.$refs.echartspie2).resize();
          Echarts.getInstanceByDom(this.$refs.paramsDataQuery.$refs.echartspie3).resize();
        })
    },
    /**
     * 下载报表
     */
    downloadExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#table"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "核心数据统计.xlsx"
        );
      } catch (e) {
        this.$message.error("文件下载失败");
      }
      return wbout;
      // 从后端接口获取报表 /web/communityClues/exportCoreData
    },
    /**
     * 刷新头部数据、折线图、和表格数据
     */
    refreshPageDate() {
      const Loading = this.$loading();
      //日期范围 默认 近7天/近3个月
      this.timeRegion = '2';
      this.dateTypeSelet(this.timeType)
      if( this.timeType == '1' ) {
        this.pickerDateType = 'daterange'
        this.date = [startTime, endTime]
      } else {
        this.pickerDateType = 'monthrange'
        const start = new Date();
        const end = new Date();
        start.setMonth(start.getMonth() - 3);
        end.setMonth(end.getMonth() - 1);
        this.date = [start, end]
      }
      Promise.all([
        this.getContentData(false),
      ]).finally(() => {
        Loading.close();
      });
    },
    /**
     * 数据类型切换
     */
    changeDataType() {
      this.curContentData = this.contentDatas[this.dataType];
      this.updateEcharts();
    },
    /**
     * 初始化echarts
     */
    initEcharts() {
      this.lineChart = Echarts.init(this.$refs.echarts);
      window.onresize = this.lineChart.resize;
      this.updateEcharts();
    },
    /**
     * 更新echarts
     * @param {Array} x x轴数据
     * @param {Array} y 当前y轴数据
     */
    updateEcharts() {
      if( !this.lineChart ) return;
      // 处理图表数据
      const x = [];
      const y = [];
      this.curContentData.forEach(item => {
        x.unshift(item.name);
        y.unshift(item.value);
      });
      // console.log(x, y);
      let option = {
        title: {
          show: Boolean(!this.curContentData.length),
          text: "暂无数据",
          left: "center",
          top: "center",
          textStyle: {
            color: "pink",
            fontSize: 16,
            fontWeight: 400
          }
        },
        xAxis: {
          show: Boolean(this.curContentData.length),
          type: "category",
          data: x
        },
        yAxis: {
          show: Boolean(this.curContentData.length),
          type: "value"
        },
        series: [
          {
            name: "当日",
            data: y,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#00CCFF"
              }
            },
            lineStyle: {
              normal: {
                color: "#00CCFF"
              }
            },
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#00CCFF"
              }
            }
          }
        ]
      };
      this.lineChart.setOption(option);
    },
    /**
     * 接口时间参数适配
     */
    normalDate(startDate, endDate) {
      // console.log('normal ', startDate, endDate)
      let start
      let end
      switch (this.timeType) {
        case "1":
          start = startDate ? new Date(startDate + "T00:00:00.000+0800") : "";
          end = endDate ? new Date(new Date(endDate + "T23:59:59.999+0800").setDate(new Date(endDate + "T23:59:59.999+0800").getDate() - 1)) : "";
          start = getYear(start, false, false);
          end = getYear(end, false, false);
          break;
        default:
          start = startDate ? new Date(startDate) : "";
          end = endDate ? new Date(endDate) : "";
          start = start.getFullYear() + "-" + get0(start.getMonth() + 1);
          end = end.getFullYear() + "-" + get0(end.getMonth() + 1);
          break;
      }
      return [start, end];
    },
    /**
     * 生成指定日期之间的日期数组 ‘YYYY-MM-DD’
     */
    getDates(startDate, endDate) {
      const dates = [];
      const start = new Date(startDate);
      const end = new Date(endDate);
      for (let date = start; date <= end; date.setDate(date.getDate() + 1)) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formattedDate = `${year}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        dates.push(formattedDate);
      }
      return dates;
    },
    /**
     * 生成指定月份之间的月份数组 ‘YYYY-MM’
     */
    getMonthList(startDateStr, endDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);
      const yearDiff = endDate.getFullYear() - startDate.getFullYear();
      const monthDiff = endDate.getMonth() - startDate.getMonth();
      const totalMonthDiff = yearDiff * 12 + monthDiff + 1; // 总月份差
      const monthList = [];

      for (let i = 0; i < totalMonthDiff; i++) {
        const currentDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth() + i,
          1
        );
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const monthStr = month < 10 ? `0${month}` : month;
        monthList.push(`${year}-${monthStr}`);
      }
      return monthList;
    },
    /**
     * 获取表格数据
     */
    getTableData() {
      this.tableData = [];
      let dateList;
      let [startData, endData] = this.normalDate(this.date[0], this.date[1])
      // 按日
      if (this.timeType === "1") {
        dateList = this.getDates(startData, endData);
      } else {
        // 按月
        dateList = this.getMonthList(startData, endData);
      }
      dateList.forEach(dateItem => {
        const record = {
          dataTime: dateItem,
          releaseVolume: 0,
          browseVolume: 0,
          remarkVolume: 0,
          likeVolume: 0,
          dailVolume: 0,
          customer: 0
        };
        for (let key in this.contentDatas) {
          if (this.contentDatas.hasOwnProperty(key)) {
            let data = this.contentDatas[key].find(
              item => item.name === dateItem
            );
            if (data) {
              switch (key) {
                case "1":
                  record["releaseVolume"] = data.value;
                  break;
                case "2":
                  record["browseVolume"] = data.value;
                  break;
                case "3":
                  record["remarkVolume"] = data.value;
                  break;
                case "4":
                  record["likeVolume"] = data.value;
                  break;
                case "5":
                  record["dailVolume"] = data.value;
                  break;
                default:
                  record["customer"] = data.value;
                  break;
              }
            }
          }
        }
        this.tableData.push(record);
      });
      this.tableData.reverse();
    },
    /**
     * 获取内容数据
     */
    getContentData(load = true) {
      let [startDate, endDate] = this.normalDate(this.date[0], this.date[1]);
      let cityName = this.cities.find((item) => item.id === this.city).name;
      return this.$ajax(
        "/web/communityClues/queryCoreData",
        Object.assign(
          {
            type: this.dataType,
            dateType: this.timeType,
            startDate,
            endDate,
            dateRegion: this.timeRegion
          },
          this.city != "00" ? { cityId: this.city, cityName } : {},
        ),
        {
          method: "post",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          load
        }
      ).then(data => {
        if( data.status == 200 ) {
          // console.log("content", data.data);
          this.contentDatas = data.data.detailList;
          this.curContentData = data.data.detailList[this.dataType];
          this.totalDataSet = [
            ...data.data.totalData.map(item => Object.freeze(item))
          ]
          // console.log('totalDataSet', this.totalDataSet)
          this.getTableData();
          this.updateEcharts();
          return data.data;
        }
      });
    },
    /**
     * 获取城市列表
     */
    getCityList(load = true) {
      return this.$ajax(
        "web/search_properties/city_name",
        {},
        {
          method: "get",
          load
        }
      ).then(data => {
        // console.log('城市列表', data.data);
        this.cities.push(
          // 让Vue不对其进行响应式初始化
          ...data.data.map(item => Object.freeze(item))
        );
        return data.data;
      });
    },
    /**
     * 获取头部所有数据
     */
    getCountAll(load = true) {
      return this.$ajax(
        "/web/communityClues/queryYesterdayOperData",
        {},
        {
          method: "get",
          load
        }
      ).then(data => {
        // console.log('头部数据', data.data)
        this.dataSet = data.data;
        return data.data;
      });
    },
    // 时间日期面板
    dateTypeSelet(type) {
      let dateType = {
        '1': [
          {
            text: "一天内",
            onClick: picker => {
              this.timeRegion = "1";
              const start = new Date();
              picker.$emit("pick", [new Date(new Date().setDate(start.getDate() - 1)), start]);
            }
          },
          {
            text: "七天内",
            onClick: picker => {
              this.timeRegion = "2";
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "30天内",
            onClick: picker => {
              this.timeRegion = "3";
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "一年内",
            onClick: picker => {
              this.timeRegion = "4";
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        '2': [
          {
            text: "上个月",
            onClick: (picker) => {
              this.timeRegion = "1";
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "近3个月",
            onClick: (picker) => {
              this.timeRegion = "2";
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              end.setMonth(end.getMonth() - 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近12个月",
            onClick: (picker) => {
              this.timeRegion = "3";
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 12);
              end.setMonth(end.getMonth() - 1);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
      this.pickerOptions.shortcuts = dateType[type] || []
    }
  }
};
</script>